module.exports = __webpack_public_path__ + "img/add-a-photo.b69f66fb.svg";